<template>
  <div class="menubar-container">
    <ul class="menu_bars" @mouseover="showContent = true">
      <div class="dropdown_base dropdown3">
        <a class="dropbtn">
          {{ time_type_info.name }}<i class="el-icon-arrow-down"></i>
        </a>
        <div
          v-show="showContent && !isAlarmMode"
          @click="showContent = false"
          class="dropdown_base-content dropdown-content3"
        >
          <a
            v-for="tp in timeTypes"
            :key="tp.value"
            :class="{ item_active: time_type_ctl == tp.value }"
            @click="time_type_ctl = tp.value"
            :title="tp.name"
          >
            {{ tp.name }}
          </a>
        </div>
      </div>

      <div class="dropdown_base dropdown4" v-show="!showGfStation">
        <a class="dropbtn"
          >{{ sensortypeInfo.label }}<i class="el-icon-arrow-down"></i
        ></a>
        <div
          v-show="showContent && !isAlarmMode"
          @click="showContent = false"
          class="dropdown_base-content dropdown-content4"
        >
          <a
            v-for="sensortypeInfo in sensortypes"
            :key="sensortypeInfo.value"
            :class="{ item_active: sensortypeValue == sensortypeInfo.value }"
            @click="sensortypeValue = sensortypeInfo.value"
            >{{ sensortypeInfo.label }}</a
          >
        </div>
      </div>
      <div class="dropdown_base dropdown4" v-show="showGfStation">
        <a class="dropbtn"
          >{{ gfSensortypeInfo.label }}<i class="el-icon-arrow-down"></i
        ></a>
        <div
          v-show="showContent && !isAlarmMode"
          @click="showContent = false"
          class="dropdown_base-content dropdown-content4"
        >
          <a
            v-for="gfSensortypeInfo in sensortypeArr"
            :key="gfSensortypeInfo.value"
            :class="{
              item_active: gfSensortypeValue.includes(gfSensortypeInfo.value)
            }"
            @click="gfSensortypeChange(gfSensortypeInfo.value)"
            >{{ gfSensortypeInfo.label }}</a
          >
        </div>
      </div>
    </ul>
    <div class="alarmStatus" v-show="isAlarmMode">
      <i
        class="rz_iconfont icon-time"
        :style="{
          color: 'red',
          fontSize: '4vh'
        }"
      ></i>
      <span class="time-text" :style="{ color: 'red' }">{{ timeVal }}</span>
      <button class="back-to-real" @click="backToReal">退出报警</button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import _ from "lodash";

const timeTypes = [
  {
    name: "实时",
    value: "real",
    default_range: [moment().subtract(24, "hours"), moment()]
  },
  {
    name: "分钟",
    value: "min",
    default_range: [moment().subtract(24, "hours"), moment()]
  },
  {
    name: "小时",
    value: "hour",
    default_range: [moment().subtract(7, "days"), moment()]
  },
  {
    name: "日",
    value: "day",
    default_range: [moment().subtract(30, "days"), moment()]
  },
  {
    name: "周",
    value: "week",
    default_range: [moment().subtract(3, "months"), moment()]
  },
  {
    name: "月",
    value: "month",
    default_range: [moment().subtract(12, "months"), moment()]
  }
];

export default {
  data() {
    return {
      timeTypes,
      map: null,
      showContent: false,
      sensortypeArr: [],
      gfSensortypeValue: []
    };
  },
  computed: {
    ...mapState([
      "page_config",
      "sensortype",
      "time_type",
      "sensortypes",
      "data_time",
      "mapMode",
      "locateAlarm",
      "showGfStation"
    ]),
    ...mapGetters(["carLayerAvailable"]),
    time_type_ctl: {
      get: function() {
        return this.time_type;
      },
      set: function(val) {
        const time_type_info = this.timeTypes.find(x => x.value === val);
        this.$store.commit("setTimeRange", time_type_info.default_range);
        this.$store.commit("setTimeType", val);
      }
    },
    time_type_info() {
      return this.timeTypes.find(x => x.value === this.time_type_ctl);
    },
    sensortypeValue: {
      get: function() {
        return this.sensortype;
      },
      set: function(val) {
        this.$store.commit("setSensortype", val);
      }
    },
    sensortypeInfo() {
      return this.sensortypes.find(x => x.value === this.sensortypeValue) ?? {};
    },
    gfSensortypeInfo() {
      let info =
        this.sensortypeArr.find(x => x.value === this.gfSensortypeValue[0]) ??
        {};
      // > 1 说明选中了CODcr/CODmn
      if (this.gfSensortypeValue.length > 1) {
        return { label: "CODcr/CODmn" };
      }
      return info;
    },
    timeVal() {
      return this.mapMode == "alarm" ? this.locateAlarm.update_time : "";
    },
    isAlarmMode() {
      return this.mapMode === "alarm";
    }
  },
  watch: {
    mapMode() {
      if (this.isAlarmMode) {
        this.$store.commit("setTimeType", "min");
      } else {
        this.$store.commit("setTimeType", this.timeTypes[0].value);
      }
    },
    locateAlarm() {
      if (this.isAlarmMode) {
        if (this.page_config.minToNow) {
          this.locateAlarm &&
            this.$store.commit("setSensortype", this.locateAlarm.data_type);
        } else {
          this.locateAlarm && this.$store.commit("setSensortype", "pm10");
        }
      } else {
        this.$store.commit("setSensortype", this.sensortypes[0].value);
      }
    },
    showGfStation(v) {
      let sensortypes = _.cloneDeep(this.sensortypes);
      if (v) {
        // 项目配置参数优先，再追加标站其它参数
        // cod单独处理
        // 微站数据cod为cod_cr, 标站数据cod为cod_mn
        let is_have_cod = sensortypes.find(x => x.value == "cod");
        if (is_have_cod) {
          // 项目参数有cod，只追加cod_mn
          const cod_mn_info = G_SENSOR_DATA_TYPE_INFO.find(
            x => x.value == "cod_mn"
          );
          sensortypes.push(cod_mn_info);
        } else {
          const cod_info = G_SENSOR_DATA_TYPE_INFO.find(x => x.value == "cod");
          sensortypes.push(cod_info);
          const cod_mn_info = G_SENSOR_DATA_TYPE_INFO.find(
            x => x.value == "cod_mn"
          );
          sensortypes.push(cod_mn_info);
        }
        const gfSensorTypes = [
          "cod",
          "ammonia_nitrogen",
          "turbidity",
          "temperature",
          "dissolved_oxygen",
          "ph",
          "conductivity",
          "zn",
          "zp"
        ];
        for (let value of gfSensorTypes) {
          let is_exist = sensortypes.find(x => x.value == value);
          if (!is_exist) {
            const sensor_info = G_SENSOR_DATA_TYPE_INFO.find(
              x => x.value == value
            );
            sensortypes.push(sensor_info);
          }
        }
        this.sensortypeArr = sensortypes;
        if (this.sensortypeValue == "cod") {
          this.gfSensortypeValue = ["cod", "cod_mn"];
        } else {
          this.gfSensortypeValue = [this.sensortypeValue];
        }
        this.$store.commit("setGfSensortype", this.gfSensortypeValue);
      } else {
        this.sensortypeArr = sensortypes;
        // > 1说明选中了cod、cod_mn
        if (this.gfSensortypeValue.length > 1) {
          this.$store.commit("setSensortype", "cod");
        } else {
          let info = this.sensortypes.find(
            x => x.value == this.gfSensortypeValue[0]
          );
          if (info) {
            this.$store.commit("setSensortype", info.value);
          } else {
            this.$store.commit("setSensortype", this.sensortypes[0].value);
          }
        }
      }
    }
  },
  mounted() {
    this.sensortypeArr = this.sensortypes;
    this.timeTypes = timeTypes.filter(x => {
      return _page_config.time_type_list.indexOf(x.value) !== -1;
    });
  },
  methods: {
    backToReal() {
      this.$store.commit("updateMapMode", "current");
    },
    gfSensortypeChange(value) {
      if (this.gfSensortypeValue.length > 1) {
        this.gfSensortypeValue = [value];
      } else {
        if (
          this.gfSensortypeValue.includes("cod") ||
          this.gfSensortypeValue.includes("cod_mn")
        ) {
          // this.gfSensortypeValue.push(value)
          this.gfSensortypeValue = ["cod", "cod_mn"];
        } else {
          this.gfSensortypeValue = [value];
        }
      }
      this.$store.commit(
        "setSensortype",
        this.gfSensortypeValue.length == 2 ? "cod" : value
      );
      this.$store.commit("setGfSensortype", this.gfSensortypeValue);
    }
  }
};
</script>

<style lang="less">
@toolbar_bg: #1c365a;
@toolbar_a_bg: #212b40;
@toolbar_a_bg_hover: #182f4e;
@menu_bg: #20426b;

.menubar-container {
  position: absolute;
  z-index: 100;
  left: 1.04vw;
  top: 2.136vh;
}

.menu_bars {
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  z-index: 100;
  border-radius: 10px;
  background-color: @menu_bg !important;
}

.dropbtn {
  cursor: pointer;
  font-size: 17px;
}

.dropbtn,
.item {
  display: inline-block;
  text-align: center;
  line-height: 5vh;
  text-decoration: none;
}

.item {
  padding-left: 0.5vw;
  text-align: left;
}

.a_disabled {
  pointer-events: none;
  background: #505052;
}

.dropdown_base-content a {
  font-size: 1.5vh;
  color: black;
}

.dropdown_base {
  display: inline-block;
  width: auto;
  height: 5vh;
  min-width: 100px;
  padding-left: 5px;
  margin: 0;
  a {
    color: white !important;
    text-decoration: none;
    display: block;
    &:hover {
      color: white !important;
    }
  }
  .dropdown_base-content {
    display: none;
    z-index: 100;
    position: absolute;
    min-width: 100px;
    display: none;
    a {
      padding: 10px;
      &:hover {
        background-color: @toolbar_a_bg_hover;
      }
    }
    background-color: @menu_bg;
    .item_active {
      background-color: @toolbar_a_bg;
    }
  }
}

.dropdown1:hover .dropdown-content1,
.dropdown2:hover .dropdown-content2,
.dropdown3:hover .dropdown-content3,
.dropdown4:hover .dropdown-content4,
.dropdown5:hover .dropdown-content5 {
  display: block;
}

.alarmStatus {
  position: absolute;
  left: 10.5vw;
  top: 0;
  width: 18vw;
  height: 5vh;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .time-text {
    font-size: 1.85vh;
    color: #2cf0f1;
  }
  .back-to-real {
    font-size: 1.3vh;
    width: 4.16vw;
    height: 2vh;
    line-height: 2vh;
    border: 1px solid #2cf0f1;
    border-radius: 3px;
    background-color: rgba(255, 255, 255, 0.15);
    color: #2cf0f1;
    margin-left: 1.2vw;
    cursor: pointer;
  }
}
</style>
